var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-wrapper"},[_c('side-bar'),_c('el-container',{staticClass:"main-container"},[_c('nav-bar'),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }